import { ADD_SESSION, ACTION_LOGOUT_INITIATED } from '../actions/types';

const initialState = {
	session_token: null,
	login: true,
	sellerPortalConfig: {}
};

export default function (state = initialState, action) {
	switch (action.type) {
		case ADD_SESSION:
			// alert(`Set Session: ${action.payload.session_token}`);
			return {
				...state,
				session_token: action.payload.session_token,
				user_type: action.payload.user_type || [],
				groupId: action.payload.group_id || "",
				sellerPortalConfig: action.payload.seller_portal_config || {},
				disableOrdersV2: false,
				login: false,
			};

		case ACTION_LOGOUT_INITIATED:
			return initialState;

		default:
			return state;
	}
}
